webpackJsonp([111451873807285],{

/***/ 1619:
/***/ (function(module, exports) {

	module.exports = {"data":{"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/people/luke-fowell/","posts":[{"fields":{"slug":"/news/artificial-intelligence-meets-the-real-world/","author":{"id":"/opt/build/repo/src/pages/people/luke-fowell.md absPath of file >>> MarkdownRemark"}},"frontmatter":{"title":"Artificial Intelligence meets the real world","templateKey":"news","thumb":{"responsive":{"childImageSharp":{"original":{"src":"/static/1160x450 ai article header image v1-7dceee5f03886d2392d2d33617822e0c.jpg"}}},"original":"/img/1160x450 ai article header image v1.jpg"},"category":"Insight"}}]},"frontmatter":{"title":"Luke Fowell"}}}]}},"pathContext":{"author":"/people/luke-fowell/"}}

/***/ })

});


// WEBPACK FOOTER //
// path---authors-luke-fowell-0064918aae191f565448.js